import { render, staticRenderFns } from "./marketWayList.vue?vue&type=template&id=4464eee0&scoped=true"
import script from "./marketWayList.vue?vue&type=script&lang=js"
export * from "./marketWayList.vue?vue&type=script&lang=js"
import style0 from "./marketWayList.vue?vue&type=style&index=0&id=4464eee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464eee0",
  null
  
)

export default component.exports